// Map TanStack/tRPC query state → RemoteStatus for resolveSyncedDetailPhase.

import { TRPCClientError } from "@trpc/client";
import type { RemoteStatus } from "./resolve-synced-detail-phase.js";

export function remoteStatusFromQuery(opts: {
	enabled: boolean;
	isFetching: boolean;
	isError: boolean;
	error: unknown;
	hasData: boolean;
}): RemoteStatus {
	if (!opts.enabled) return "idle";
	if (opts.isFetching && !opts.hasData) return "pending";
	if (opts.hasData) return "success";
	if (opts.isError) {
		if (opts.error instanceof TRPCClientError && opts.error.data?.code === "NOT_FOUND") {
			return "not_found";
		}
		return "error";
	}
	return "idle";
}
